import clsx from 'clsx'
import { uniqueId } from 'lodash-es'
import type { PropsWithChildren, ReactNode } from 'react'

import type { PropsWithClassName } from '@fv/client-types'

type Props = PropsWithClassName<
  PropsWithChildren<{
    title: ReactNode
    name?: string
    titleClassName?: string
  }>
>
export const AdminCollapse = ({
  className,
  title,
  titleClassName,
  children,
  name,
}: Props) => {
  const id = name ?? uniqueId()
  return (
    <div className={clsx('collapse-arrow collapse', className)}>
      <input type="checkbox" className="hidden" id={id} name={id} />
      <label htmlFor={id} className={clsx(titleClassName, 'collapse-title')}>
        {title}
      </label>
      <div className="collapse-content w-full overflow-hidden">{children}</div>
    </div>
  )
}
